var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboCircleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.90476C16.9667 3.90476 20.5952 7.53333 20.5952 12C20.5952 16.4667 16.9667 20.0952 12.5 20.0952C8.03333 20.0952 4.40476 16.4667 4.40476 12C4.40476 7.53333 8.03333 3.90476 12.5 3.90476ZM12.5 2C6.97619 2 2.5 6.47619 2.5 12C2.5 17.5238 6.97619 22 12.5 22C18.0238 22 22.5 17.5238 22.5 12C22.5 6.47619 18.0238 2 12.5 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2429 16.8191L6.18574 12.762C5.88098 12.4572 6.10002 11.9524 6.51907 11.9524H7.86193C7.98574 11.9524 8.10955 12.0001 8.19526 12.0953L10.2238 14.1239C10.4143 14.3143 10.7095 14.3143 10.9 14.1239L16.6238 8.40006C16.7095 8.31434 16.8334 8.2572 16.9572 8.2572H18.3C18.7286 8.2572 18.9381 8.77149 18.6334 9.06673L10.9095 16.8191C10.7191 17.0096 10.4238 17.0096 10.2334 16.8191H10.2429Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboCircleCheck);
export default __webpack_public_path__ + "static/media/FBOCircleCheck.1a03fc8eaf0c81f2441b7723848c2aa9.svg";
export { ForwardRef as ReactComponent };